import { isBetaPublicRoutePath } from './pages/beta-public-pages'

import '@proj-airi/font-cjkfonts-allseto/index.css'
import '@proj-airi/font-xiaolai/index.css'
import '@unocss/reset/tailwind.css'
import './styles/main.css'
import 'uno.css'

async function mountStageWeb() {
  if (isBetaPublicRoutePath(window.location.pathname)) {
    const { mountPublicBetaApp } = await import('./public-entry')
    mountPublicBetaApp()
    return
  }

  const { mountStageWebApp } = await import('./stage-entry')
  await mountStageWebApp()
}

void mountStageWeb()
